

export default {
  title1: '无锡凯尔克仪表阀门有限公司',
  title2: '中国江苏省无锡市新吴区鸿山镇后宅德育路6号',
  callMe: {
    title: '联系我们',
    list: [
      `电话: +86-(0)510-85141699（杜经理）`,
      // `电话：+1(778)873 8683（海外热线）`,
      `邮箱: info@kelkflow.com.cn`,
      `或直接添加客服联系`,
    ]
  },
  imgList: [
    {
      icon: require("@/assets/images/public/i10.png"),
      qrIcon: require("@/assets/images/public/img1.png"),
      selectIcon: require("@/assets/images/callMe/1-1.png"),
      name: "公众号",
      isShow:false
    },
    {
      icon: require("@/assets/images/public/i9.png"),
      qrIcon: require("@/assets/images/public/img2.png"),
      selectIcon: require("@/assets/images/callMe/3-3.png"),
      name: "视频号",
      isShow:false
    },
    {
      icon: require("@/assets/images/public/i8.png"),
      qrIcon: require("@/assets/images/public/img3.png"),
      selectIcon: require("@/assets/images/callMe/2-2.png"),
      name: "小程序",
      isShow:false
    }
  ],
  qrcodeList: [
    {
      icon: require("@/assets/images/public/i4.png"),
      qrIcon: require("@/assets/images/public/img4.png"),
      name: "微信",
      selectIcon: require("@/assets/images/callMe/4-4.png"),
      seen: false
    },
    {
      icon: require("@/assets/images/public/i6.png"),
      qrIcon: require("@/assets/images/public/img5.png"),
      name: "企业微信",
      selectIcon: require("@/assets/images/callMe/6-6.png"),
      seen: false
    },
    {
      icon: require("@/assets/images/public/i5.png"),
      qrIcon: require("@/assets/images/public/img6.png"),
      selectIcon: require("@/assets/images/callMe/5-5.png"),
      name: "微信客服",
      seen: false
    }
  ],
  phoneTxt: '24小时服务热线',
  attentionOurTxt: '关注我们',
  copyrightTxt: '无锡凯尔克仪表阀门有限公司版权所【备案号】苏ICP备20021752号',
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/footer.js